import React, { ReactNode, useState, useEffect, useMemo, Fragment } from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { IoSearchSharp, IoSettingsOutline } from 'react-icons/io5';

import complaintsImage from '../../assets/Complaints.png';
import vendorsBlueImage from '../../assets/Vendors-blue.png';
import vendorswhiteImage from '../../assets/Vendors-white.png';
import dashboardBlueImage from '../../assets/Dashboard-blue.png';
import dashboardwhiteImage from '../../assets/Dashboard-white.png';
import blueCompaintsImage from '../../assets/Compaints-blue.png';
import bookingBlueImage from '../../assets/bookingBlueImage.png';
import bookingWhiteImage from '../../assets/bookingWhiteImage.png';
import feedbackBlueImage from '../../assets/feedbackBlueImage.png';
import feedbackWhiteImage from '../../assets/feedbackWhiteImage.png';
import serviceBlueImage from '../../assets/serviceBlueImage.png';
import serviceWhiteImage from '../../assets/serviceWhiteImage.png';
import enquiryBlueImage from '../../assets/enquiryBlueImage.png';
import enquiryWhiteImage from '../../assets/enquiryWhiteImage.png';
import chat from '../../assets/chatLogo.png';
import ChatBlue from '../../assets/chatblue.png';
import callBack from '../../assets/callBack.png';
import callBackBlue from '../../assets/callBackBlue.png';
import HelpCenter from '../../assets/HelpCenter.png';
import Sidebar from '../../common/layout/Sidebar';
import DashboardSidebarItem from '../../common/SidebarItem';
import Navbar from '../../common/layout/Navbar';
import Complaints from '../complaints/Complaints';
import Notification from '../../notifications/Notification';
import { useSocket } from '../../Contexts/SocketContext';
import SettingsSidebar from '../settings/SettingsSidebar';
import SettingUsers from '../setting-users/SettingUsers';
import { useGuideContext } from '../../Contexts/GuidingContext';
import getCustomMenuEffect from '../../hooks/Menu';
import { FaRegBell } from 'react-icons/fa';
import { useMenuContext } from '../../Contexts/MenuContext';
interface dashboardLayoutProps {
  children: ReactNode;
}
const DashboardLayout = (props: dashboardLayoutProps) => {
  const location = useLocation();
  const { children } = props;
  const { socketInstance } = useSocket();
  const { menuList } = useMenuContext();
  const companyUuid = sessionStorage.getItem('companyUuid');
  const businessType = sessionStorage.getItem('businessType');

  const { menu } = getCustomMenuEffect(companyUuid ? companyUuid : '');

  const [searchQuery, setSearchQuery] = useState('');
  const [activeSidebar, setActiveSidebar] = useState(1);
  const [hasNotifications, setHasNotifications] = useState([]);
  const [searchInputValue, setSearchInputValue] = useState('');
  const [hospitalitySidebar, setHospitalitySidebar] = useState<any>([]);

  const { currentStep, handleNextStep } = useGuideContext();
  const navigate = useNavigate();

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInputValue(e.target.value);
  };
  const onClickSearchhandler = () => {
    if (searchInputValue !== '') {
      setSearchQuery(searchInputValue);
    }
  };
  const handleSettingsClick = () => {
    navigate('/settings/faq');
    handleNextStep(2);
  };

  useMemo(() => {
    if (
      location.pathname === '/notifications' ||
      location.pathname === '/complaints' ||
      location.pathname === '/settings/users'
    ) {
      setSearchInputValue('');
      setSearchQuery('');
    }
  }, [location.pathname]);
  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const trimmedValue = e.currentTarget.value.trim();
    if (trimmedValue === '') {
      setSearchQuery(trimmedValue);
    } else if (e.key === 'Enter') {
      setSearchQuery(trimmedValue);
    }
  };

  const handleSidebarImg = (path: string) => {
    if (path === 'check-in') return { activeImg: vendorsBlueImage, inActiveImg: vendorswhiteImage };
    if (path === 'booking') return { activeImg: bookingBlueImage, inActiveImg: bookingWhiteImage };
    if (path === 'services') return { activeImg: serviceBlueImage, inActiveImg: serviceWhiteImage };
    if (path === 'enquiry') return { activeImg: enquiryBlueImage, inActiveImg: enquiryWhiteImage };
    if (path === 'complaint')
      return { activeImg: blueCompaintsImage, inActiveImg: complaintsImage };
    if (path === 'feedback')
      return { activeImg: feedbackBlueImage, inActiveImg: feedbackWhiteImage };
    if (path === 'chat with agent') return { activeImg: ChatBlue, inActiveImg: chat };
    return { activeImg: null, inActiveImg: null };
  };

  const sidebarItems = [
    {
      id: 1,
      activeImg: dashboardBlueImage,
      inActiveImg: dashboardwhiteImage,
      label: 'Dashboard',
      menuUrl: '/dashboard'
    },
    {
      id: 2,
      activeImg: blueCompaintsImage,
      inActiveImg: complaintsImage,
      label: 'Complaints',
      menuUrl: '/complaints'
    },
    {
      id: 3,
      activeImg: vendorsBlueImage,
      inActiveImg: vendorswhiteImage,
      label: 'Vendors',
      menuUrl: '/vendors'
    },
    {
      id: 4,
      activeImg: ChatBlue,
      inActiveImg: chat,
      label: 'Chat',
      menuUrl: '/chat'
    }
  ];

  useEffect(() => {
    if (menuList.length > 0 && businessType !== 'Retail' && businessType !== 'WordpressRetail' && businessType !== 'OdooRetail') {
      const newObject = {
        id: 1,
        activeImg: dashboardBlueImage,
        inActiveImg: dashboardwhiteImage,
        label: 'Dashboard',
        menuUrl: '/dashboard'
      };
      const formattedItem = menuList
        .filter((str: any) => str.toLowerCase() !== 'faq')
        .map((str: any, idx: number) => ({
          id: idx + 2,
          activeImg: handleSidebarImg(str.toLowerCase()).activeImg,
          inActiveImg: handleSidebarImg(str.toLowerCase()).inActiveImg,
          label: str === 'Chat With Agent' ? 'Chat' : str,
          menuUrl: `/${str === 'Chat With Agent' ? 'chat' : str.toLowerCase()}`
        }));

      const callbackObject = {
        id: formattedItem.length + 2,
        activeImg: callBackBlue,
        inActiveImg: callBack,
        label: 'Callback',
        menuUrl: '/callback'
      };

      const vendorObject = {
        id: formattedItem.length + 3,
        activeImg: vendorsBlueImage,
        inActiveImg: vendorswhiteImage,
        label: 'Vendors',
        menuUrl: '/vendors'
      };

      const updatedSidebar = [
        newObject,
        ...formattedItem,
        callbackObject,
        businessType === 'Ecommerce' && vendorObject
      ];
      setHospitalitySidebar(updatedSidebar);
    }
  }, [JSON.stringify(menuList)]);

  const handleSidebarItemsClick = (sidebarItemId: number) => {
    setActiveSidebar(sidebarItemId);
  };
  useEffect(() => {
    if (socketInstance) {
      setTimeout(() => {
        socketInstance.emit('getNotifications');
      }, 300);
      socketInstance.on('notifications', (notifications: any) => {
        const mappedunreadNotifications = notifications.filter(
          (notification: any) => !notification.read
        );
        setHasNotifications(mappedunreadNotifications);
      });

      socketInstance.on('updateNotifications', (notification: any) => {
        socketInstance.emit('getNotifications');
      });
    }
  }, [socketInstance]);
  const inputHeader =
    location.pathname === '/complaints' ||
      location.pathname === '/notifications' ||
      location.pathname === '/settings/users' ? (
      <div className="mt-1 md:mt-5">
        <div
          className={`flex items-center bg-[#1E1E1E] text-white rounded-3xl ${location.pathname === '/complaints' ? 'ms-[-3px]' : ''} ${location.pathname === '/settings/users' ? 'ms-[-19px]' : ''}   px-4 py-4 w-[200px] sm:w-[364px] md:h-[38px] h-[30px] border-[2px] border-[#FFFFFF]`}
        >
          <input
            value={searchInputValue}
            type="text"
            placeholder="Search here"
            onChange={handleSearch}
            onKeyUp={handleKeyUp}
            className="bg-transparent outline-none  flex-grow placeholder-[#FFFFFF] md:placeholder:text-[18px] placeholder:text-[12px] md:text-[18px] text-[12px]"
          />

          <button onClick={onClickSearchhandler}>
            <IoSearchSharp className="sm:h-[20px] sm:w-[20px] h-4 w-4  text-[#FFFFFF]" />
          </button>
        </div>
      </div>
    ) : (
      <div></div>
    );
  const memoizedSearchQuery = useMemo(() => searchQuery, [searchQuery]);
  const bellAndSettingsIcon = (
    <>
      {currentStep === 1 && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-10"></div>
          <div className="relative z-20">
            <div className="absolute w-[11rem] top-[2rem] lg:left-0 right-[-85px]">
              <div role="alert" className="rounded-lg  bg-[#006BEA] p-3">
                <h2 className="block font-normal md:text-sm text-[#FFFFFF]">
                  {' '}
                  Click on the setting where you can get into the setting{' '}
                </h2>
              </div>
            </div>
          </div>
        </>
      )}
      {/* {businessType === 'Retail' && ( */}
      <div className="relative mx-2 lg:mx-0">
        <Link to="/notifications">
          <FaRegBell
            className={`w-[20px] h-[20px]  ${location.pathname.startsWith('/notifications') ? 'text-[#006BEA]' : 'text-white'}`}
          />
          {hasNotifications.length > 0 && (
            <span
              className={`absolute top-[-5px] ${hasNotifications.length < 99 ? 'right-0 left-2 bottom-5' : 'right-[-5px]'} inline-flex items-center justify-center
    ${hasNotifications.length < 99 ? 'w-4 h-4 p-[2px]' : 'w-[18px] h-[18px] px-[2px]'} 
    ${hasNotifications.length < 99 ? 'text-[9px]' : 'text-[8px]'} 
    bg-red-500 text-white font-semibold rounded-full`}
            >
              {hasNotifications.length > 99 ? '99+' : hasNotifications.length}
            </span>
          )}
        </Link>

      </div>
      {/* )} */}

      <div className="relative z-20">
        <Link to="/settings/faq" onClick={handleSettingsClick}>
          <IoSettingsOutline
            className={`w-[20px] h-[20px]  ${location.pathname.startsWith('/settings') ? 'text-[#006BEA]' : 'text-white'}`}
          />
        </Link>
        {currentStep === 1 && (
          <div onClick={handleSettingsClick} className="absolute top-3 left-1 cursor-pointer">
            <div className="absolute animate-ping w-5 h-5 rounded-full bg-gradient-to-r from-blue-400 to-[#006bea] opacity-20"></div>
            <div className="relative w-3 h-3 rounded-full  bg-[#006bea]  "></div>
          </div>
        )}
      </div>
    </>
  );

  const supportAndHelpdeskContent = (
    <div className={`flex items-center gap-4 rounded-md ml-7 mt-5 transition`}>
      <img className={`text-lg lg:text-xl`} src={HelpCenter} alt="help" />

      <span className="text-sm lg:text-[16px]">
        <Link to="/support">Help Center</Link>
      </span>
    </div>
  );
  return (
    <div
      className="flex h-screen bg-[1E1E1E] mb-0 text-white  overflow-y-hidden overflow-x-hidden"
    // key={falseState}
    >
      <Sidebar>
        <div className="flex flex-col justify-between ms-2">
          <div>
            <div className="space-y-2">
              {(businessType === 'Retail' || businessType === 'WordpressRetail' || businessType === 'OdooRetail' ? sidebarItems : hospitalitySidebar).map((item: any, index: number) => {
                const isActive = location.pathname.startsWith(item.menuUrl);
                return (
                  <Fragment key={index}>
                    {item && <DashboardSidebarItem
                      key={item.id}
                      image={isActive ? item.activeImg : item.inActiveImg}
                      label={item.label}
                      isActive={activeSidebar === item.id}
                      handleSidebarItemsClick={handleSidebarItemsClick}
                      id={item.id}
                      url={
                        businessType === 'Ecommerce' && item.menuUrl === '/complaint'
                          ? '/complaints'
                          : item.menuUrl
                      }
                    />}
                  </Fragment>
                );
              })}
            </div>
          </div>
        </div>
      </Sidebar>

      <Navbar
        header={inputHeader}
        bellAndSettingsIcon={bellAndSettingsIcon}
        layoutPadding={true}
      // setFalseState={setFalseState}
      >
        {location.pathname === '/complaints' && <Complaints searchQuery={memoizedSearchQuery} />}
        {location.pathname === '/notifications' && (
          <Notification searchQuery={memoizedSearchQuery} />
        )}
        {location.pathname === '/settings/users' && (
          <SettingsSidebar>
            <SettingUsers searchQuery={memoizedSearchQuery} />
          </SettingsSidebar>
        )}
        {location.pathname !== '/complaints' && location.pathname !== '/notifications' && children}
      </Navbar>
    </div>
  );
};

export default DashboardLayout;
